import React from "react";
import PropTypes from 'prop-types';
import {
    InputAdornment,
    TextField
} from "@material-ui/core";
import isNumeric from "../../utils/isNumeric";

const CurrencyField = ({label, value}) => (
    <TextField
        label={label}
        value={
            isNumeric(value)
                ? value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
                : '—'
        }
        InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        readOnly
        fullWidth
    />
);

CurrencyField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.number,
};

CurrencyField.defaultProps = {
    value: null,
};

export default CurrencyField;
